var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-card-header",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("b-card-title", [_vm._v("Quantity of Sales Over Time")]),
          _c(
            "b-form",
            { attrs: { inline: "" } },
            [
              _c("b-form-datepicker", {
                staticClass: "mr-2",
                attrs: { max: _vm.endDate, placeholder: "Start Date" },
                model: {
                  value: _vm.startDate,
                  callback: function ($$v) {
                    _vm.startDate = $$v
                  },
                  expression: "startDate",
                },
              }),
              _c("b-form-datepicker", {
                attrs: { min: _vm.startDate, placeholder: "End Date" },
                model: {
                  value: _vm.endDate,
                  callback: function ($$v) {
                    _vm.endDate = $$v
                  },
                  expression: "endDate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("apexchart", {
        attrs: {
          type: "line",
          height: _vm.chartOptions.chart.height,
          options: _vm.chartOptions,
          series: _vm.series,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }